// src/pages/AccountPage.tsx
import React from 'react';
import { Box } from '@mui/material';
import UserAccountInfo from '../components/authentication/UserAccountInfo';
import AccountsTable from '../components/authentication/AccountsTable';
import AccountModal from '../components/authentication/AccountModal';
import ChangePasswordModal from '../components/authentication/ChangePasswordModal';
import RoleBasedAccess from '../services/RoleBasedAccess';
import { AccountProvider, useAccountContext } from '../context/AccountContext';

const AccountPageContent: React.FC = () => {
  const { showSignUp, selectedAccount, isChangePasswordOpen, closeModal, setIsChangePasswordOpen } = useAccountContext();

  return (
    <Box sx={{ 
      padding: 2,
      height: 'calc(100vh - 64px)', 
      overflow: 'none' 
      }}>
      <UserAccountInfo />
      <AccountModal open={showSignUp} onClose={closeModal} account={selectedAccount} />
      <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
        <AccountsTable />
      </RoleBasedAccess>
      <ChangePasswordModal
        open={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </Box>
  );
}

const AccountPage: React.FC = () => {
  return (
    <AccountProvider>
      <AccountPageContent />
    </AccountProvider>
  );
};

export default AccountPage;